/**
 * ULTALIFE Buy Box Enhancer — Universal (All Products)
 * Detects product handle from URL and applies correct brand color + enhancements.
 * Products: Blood Pressure, Prostate, Uric Go, Her Harmony, Thyroid
 */
(function () {
  'use strict';

  // ─── PRODUCT COLOR MAP ───
  var PRODUCT_COLORS = {
    'advanced-blood-pressure-support': {
      accent:      '#922366',
      accentDark:  '#7A1C55',
      accentLight: '#f9f0f5',
      text:        '#2A1020',
      subText:     '#4A2035',
      subBorder:   '#D0C0CC',
      subDivider:  '#EDD8E6',
      bodyClass:   'ul-bp-page',
    },
    'advanced-prostate-complex': {
      accent:      '#1a5fa8',
      accentDark:  '#134a85',
      accentLight: '#eef4fb',
      text:        '#0D1F35',
      subText:     '#1a3a5c',
      subBorder:   '#B8CDE0',
      subDivider:  '#D5E5F2',
      bodyClass:   'ul-prostate-page',
    },
    'uric-go': {
      accent:      '#c0392b',
      accentDark:  '#962d22',
      accentLight: '#fdf0ee',
      text:        '#2A0D0A',
      subText:     '#5C1A14',
      subBorder:   '#E0B8B5',
      subDivider:  '#F2D5D3',
      bodyClass:   'ul-uric-page',
    },
    'her-harmony': {
      accent:      '#0B8A9A',
      accentDark:  '#086e7a',
      accentLight: '#edf7f8',
      text:        '#032A2E',
      subText:     '#0A5560',
      subBorder:   '#A8D8DE',
      subDivider:  '#D0EEF1',
      bodyClass:   'ul-harmony-page',
    },
    'advanced-thyroid-support': {
      accent:      '#2e7d32',
      accentDark:  '#1b5e20',
      accentLight: '#eef5ee',
      text:        '#0D2010',
      subText:     '#1a4a1e',
      subBorder:   '#B8D8BA',
      subDivider:  '#D5EDD6',
      bodyClass:   'ul-thyroid-page',
    },
  };

  // ─── DETECT PRODUCT FROM URL ───
  var pathParts = window.location.pathname.split('/');
  var productHandle = '';
  var prodIdx = pathParts.indexOf('products');
  if (prodIdx !== -1 && pathParts[prodIdx + 1]) {
    productHandle = pathParts[prodIdx + 1].split('?')[0];
  }

  var colors = PRODUCT_COLORS[productHandle];
  if (!colors) return; // Not one of our enhanced products

  // ─── STEP 1: Mark the body so product-specific CSS activates ───
  document.body.classList.add(colors.bodyClass);

  // ─── STEP 2: Fix secondary CTA anchor links ───
  function fixSecondaryCTAs() {
    document.querySelectorAll('a[href="#product-form"]').forEach(function(link) {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        var target = document.querySelector('[class*="product-options-radio"]:not([class*="item"]):not([class*="body"])') ||
                     document.querySelector('product-to-cart') ||
                     document.querySelector('product-form');
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    });
  }

  // ─── STEP 3: Enhance pack selector cards ───
  function enhanceBuyBox() {
    var radioItems = document.querySelectorAll('[class*="product-options-radio-item"]:not([class*="body"]):not([class*="value"]):not([class*="title"]):not([class*="price"]):not([class*="input"])');
    var items = Array.prototype.filter.call(radioItems, function(el) {
      return el.tagName === 'LABEL';
    });
    if (!items.length) return;

    items.forEach(function (item, index) {
      var titleEl = item.querySelector('[class*="product-options-radio-item-title"]');
      if (!titleEl) return;
      var fullText = titleEl.textContent.trim();

      // Extract savings badge
      var savingsMatch = fullText.match(/Save\s+(\$[\d,.]+)/i);
      if (savingsMatch && !item.querySelector('.ul-variant-savings')) {
        var badge = document.createElement('span');
        badge.className = 'ul-variant-savings';
        badge.textContent = 'Save ' + savingsMatch[1];
        badge.style.cssText = 'display:inline-block; background:' + colors.accentLight + '; color:' + colors.accentDark + '; font-size:10px; font-weight:700; border-radius:4px; padding:2px 7px; margin-top:4px; border:1px solid ' + colors.subBorder + ';';
        var body = item.querySelector('[class*="product-options-radio-item-body"]');
        if (body) body.appendChild(badge);
      }

      // Split title into pack name + supply duration
      var parts = fullText.split(/\s*[–—-]\s*/);
      if (parts.length >= 2) {
        var packPart = parts[0].trim();
        var supplyPart = parts.find(function(p) { return /day supply/i.test(p); });
        if (supplyPart && !titleEl.querySelector('.ul-supply-duration')) {
          titleEl.innerHTML = '';
          var packSpan = document.createElement('span');
          packSpan.style.cssText = 'display:block; font-size:14px; font-weight:800; color:' + colors.text + ';';
          packSpan.textContent = packPart;
          var supplySpan = document.createElement('span');
          supplySpan.className = 'ul-supply-duration';
          supplySpan.style.cssText = 'display:block; font-size:11px; font-weight:600; color:#666; margin-top:1px;';
          supplySpan.textContent = supplyPart;
          titleEl.appendChild(packSpan);
          titleEl.appendChild(supplySpan);
        }
      }

      // Add "Best Value" badge to 6-pack
      var priceEl = item.querySelector('[class*="product-options-radio-item-price"]');
      if (priceEl && index === 2 && !item.querySelector('.ul-best-value')) {
        var bvBadge = document.createElement('span');
        bvBadge.className = 'ul-best-value';
        bvBadge.textContent = 'BEST VALUE';
        bvBadge.style.cssText = 'display:inline-block; background:' + colors.accent + '; color:#fff; font-size:9px; font-weight:900; border-radius:3px; padding:2px 6px; margin-top:3px; letter-spacing:0.5px;';
        var body2 = item.querySelector('[class*="product-options-radio-item-body"]');
        if (body2) body2.appendChild(bvBadge);
      }

      // Color the selected card border
      item.style.setProperty('--selected-border-color', colors.accent);
    });
  }

  // ─── STEP 4: Override ATC button color ───
  function overrideAtcButtonColor() {
    // Override via CSS custom properties on the product-to-cart element
    var ptc = document.querySelector('product-to-cart');
    if (ptc) {
      ptc.style.setProperty('--color-g-button-bg', colors.accent, 'important');
      ptc.style.setProperty('--color-g-button-text', '#ffffff', 'important');
    }
    // Also override on the body class level via inline style injection
    if (!document.getElementById('ul-btn-override-' + colors.bodyClass)) {
      var style = document.createElement('style');
      style.id = 'ul-btn-override-' + colors.bodyClass;
      style.textContent = [
        '.' + colors.bodyClass + ', .' + colors.bodyClass + ' product-to-cart {',
        '  --color-g-button-bg: ' + colors.accent + ' !important;',
        '  --color-g-button-text: #ffffff !important;',
        '}',
        '.' + colors.bodyClass + ' .\\#button,',
        '.' + colors.bodyClass + ' [class*="\\#button"] {',
        '  --bg-color: ' + colors.accent + ' !important;',
        '  --bg-hover-color: ' + colors.accentDark + ' !important;',
        '  --bg-gradient: ' + colors.accent + ' !important;',
        '  --color-g-button-bg-gradient: ' + colors.accent + ' !important;',
        '}',
        '.' + colors.bodyClass + ' product-dynamic-checkout {',
        '  margin-top: 0 !important;',
        '  --color-g-button-bg: transparent !important;',
        '  --bg-color: transparent !important;',
        '}',
      ].join('\n');
      document.head.appendChild(style);
    }
  }

  // ─── STEP 5: Color variant selector labels ───
  function colorVariantLabels() {
    var checkedInputs = document.querySelectorAll('[class*="product-options-radio-item"] input[type="radio"]:checked');
    checkedInputs.forEach(function(input) {
      var label = input.closest('label');
      if (label) {
        var body = label.querySelector('[class*="product-options-radio-item-body"]');
        if (body) {
          body.style.setProperty('border-color', colors.accent, 'important');
          body.style.setProperty('box-shadow', '0 0 0 1px ' + colors.accent, 'important');
        }
      }
    });
  }

  // ─── STEP 6: Build Subscribe & Save card ───
  function buildSubscribeCard() {
    if (document.getElementById('ul-sub-card-custom')) return;

    var appContainer = document.querySelector('.shopify_subscriptions_app_container');
    if (!appContainer) return;

    var subRadio = appContainer.querySelector('input[data-radio-type="selling_plan"]');
    var oneTimeRadio = appContainer.querySelector('input[data-radio-type="one_time"]');
    if (!subRadio) return;

    // Get subscription price — use server-side Liquid price (most reliable)
    var subPrice = '';
    if (window.UL_SUB_PRICE && window.UL_SUB_PRICE !== null) {
      subPrice = '$ ' + parseFloat(window.UL_SUB_PRICE).toFixed(2) + ' USD';
    } else if (window.UL_VARIANT_PRICE && window.UL_VARIANT_PRICE !== null) {
      // Fallback: compute 15% off the server-rendered variant price
      var discounted = (parseFloat(window.UL_VARIANT_PRICE) * 0.85).toFixed(2);
      subPrice = '$ ' + discounted + ' USD';
    } else {
      // Last resort: try to read from app widget
      var subPriceEl = appContainer.querySelector('.in_widget_price');
      subPrice = subPriceEl ? subPriceEl.textContent.trim() : '';
    }

    // NOW hide the entire app block wrapper (keeps inputs in DOM for Shopify to process)
    var appBlock = appContainer.closest('.shopify-app-block') || appContainer.parentNode;
    if (appBlock) {
      appBlock.style.cssText = 'position:absolute; opacity:0; pointer-events:none; height:0; overflow:hidden; margin:0; padding:0; border:none; width:1px;';
    }

    var card = document.createElement('div');
    card.id = 'ul-sub-card-custom';
    card.className = 'ul-sub-card';
    card.setAttribute('role', 'button');
    card.setAttribute('tabindex', '0');
    card.setAttribute('aria-label', 'Subscribe and Save 15%');
    card.style.cssText = 'border:2px solid ' + colors.accent + '; border-radius:12px; background:linear-gradient(135deg,' + colors.accentLight + ' 0%,#fff 100%); padding:16px 18px 14px; margin-top:14px; cursor:pointer; position:relative; transition:box-shadow 0.18s ease;';

    card.innerHTML = [
      '<div style="position:absolute; top:-11px; left:18px; background:' + colors.accent + '; color:#fff; font-size:9px; font-weight:900; letter-spacing:0.8px; padding:3px 8px; border-radius:4px; text-transform:uppercase; white-space:nowrap;">MOST POPULAR</div>',
      '<div style="display:flex; justify-content:space-between; align-items:center; margin-bottom:10px;">',
        '<div style="display:flex; align-items:center; gap:8px;">',
          '<div id="ul-sub-dot" style="width:16px; height:16px; border-radius:50%; border:2px solid ' + colors.accent + '; background:#fff; flex-shrink:0; display:flex; align-items:center; justify-content:center;"></div>',
          '<span style="font-size:14px; font-weight:800; color:' + colors.accent + '; text-transform:uppercase; letter-spacing:0.4px;">Subscribe &amp; Save 15%</span>',
        '</div>',
        (subPrice ? '<div style="display:flex; align-items:baseline; gap:4px;"><span style="font-size:15px; font-weight:800; color:' + colors.accent + ';">' + subPrice + '</span><div style="font-size:11px; color:#666; margin-left:4px;">per month</div></div>' : ''),
      '</div>',
      '<ul style="list-style:none; margin:0; padding:0; display:flex; flex-direction:column; gap:5px;">',
        '<li style="font-size:12px; font-weight:600; color:' + colors.subText + '; display:flex; align-items:center; gap:6px;"><span style="color:#1A7A4A; font-weight:900; font-size:13px;">✓</span> Save 15% on every order</li>',
        '<li style="font-size:12px; font-weight:600; color:' + colors.subText + '; display:flex; align-items:center; gap:6px;"><span style="color:#1A7A4A; font-weight:900; font-size:13px;">✓</span> Free shipping on every delivery</li>',
        '<li style="font-size:12px; font-weight:600; color:' + colors.subText + '; display:flex; align-items:center; gap:6px;"><span style="color:#1A7A4A; font-weight:900; font-size:13px;">✓</span> Skip, pause, or cancel anytime</li>',
        '<li style="font-size:12px; font-weight:600; color:' + colors.subText + '; display:flex; align-items:center; gap:6px;"><span style="color:#1A7A4A; font-weight:900; font-size:13px;">✓</span> Priority customer support</li>',
      '</ul>',
    ].join('');

    var appBlockInsert = appContainer.closest('.shopify-app-block') || appContainer.parentNode;
    appBlockInsert.parentNode.insertBefore(card, appBlockInsert.nextSibling);

    var isSubSelected = subRadio.checked;
    function updateDot() {
      var dot = document.getElementById('ul-sub-dot');
      if (!dot) return;
      if (isSubSelected) {
        dot.style.background = colors.accent;
        dot.style.boxShadow = 'inset 0 0 0 3px #fff';
        card.style.boxShadow = '0 0 0 1px ' + colors.accent;
      } else {
        dot.style.background = '#fff';
        dot.style.boxShadow = '';
        card.style.boxShadow = '';
      }
    }

    card.addEventListener('click', function() {
      subRadio.checked = true;
      isSubSelected = true;
      updateDot();
      subRadio.dispatchEvent(new Event('change', { bubbles: true }));
      subRadio.dispatchEvent(new Event('input', { bubbles: true }));
    });
    card.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); card.click(); }
    });
    if (oneTimeRadio) {
      oneTimeRadio.addEventListener('change', function() { isSubSelected = false; updateDot(); });
    }
    subRadio.addEventListener('change', function() { isSubSelected = subRadio.checked; updateDot(); });
    updateDot();
  }

  function waitForAppAndBuild() {
    var attempts = 0;
    function tryBuild() {
      var container = document.querySelector('.shopify_subscriptions_app_container');
      var subRadio = container ? container.querySelector('input[data-radio-type="selling_plan"]') : null;
      // Also wait for the price to be rendered by the app
      var priceEl = container ? container.querySelector('.in_widget_price') : null;
      var priceReady = priceEl && priceEl.textContent.trim() !== '';
      if (container && subRadio && priceReady) {
        buildSubscribeCard();
      } else if (container && subRadio && attempts >= 15) {
        // Price never loaded — build anyway with fallback price calculation
        buildSubscribeCard();
      } else if (attempts < 30) {
        attempts++;
        setTimeout(tryBuild, 150);
      }
    }
    tryBuild();
  }

  // ─── STEP 7: Fix gap between ATC and Shop Pay buttons ───
  function fixButtonGap() {
    var ptc = document.querySelector('product-to-cart');
    if (!ptc) return;
    var formDiv = ptc.parentNode;
    if (!formDiv || formDiv.tagName !== 'DIV') {
      formDiv = ptc.closest('div') || ptc.parentNode;
    }
    if (!formDiv) return;
    formDiv.style.setProperty('display', 'flex', 'important');
    formDiv.style.setProperty('flex-direction', 'column', 'important');
    formDiv.style.setProperty('gap', '12px', 'important');
    var pdc = formDiv.querySelector('product-dynamic-checkout');
    if (pdc) pdc.style.setProperty('margin-top', '0', 'important');
  }

  // ─── RUN ALL ───
  function runAll() {
    fixSecondaryCTAs();
    enhanceBuyBox();
    overrideAtcButtonColor();
    colorVariantLabels();
    waitForAppAndBuild();
    fixButtonGap();
    setTimeout(fixButtonGap, 300);
    setTimeout(fixButtonGap, 800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runAll);
  } else {
    runAll();
  }

  // Re-run on DOM mutations (variant changes)
  var observer = new MutationObserver(function (mutations) {
    var shouldRun = false;
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length || mutations[i].type === 'characterData') {
        shouldRun = true;
        break;
      }
    }
    if (shouldRun) {
      enhanceBuyBox();
      overrideAtcButtonColor();
      colorVariantLabels();
      if (!document.getElementById('ul-sub-card-custom')) {
        waitForAppAndBuild();
      }
    }
  });
  document.addEventListener('DOMContentLoaded', function () {
    var productMeta = document.querySelector('[class*="product-meta"]');
    if (productMeta) {
      observer.observe(productMeta, { childList: true, subtree: true, characterData: true });
    }
  });
})();
